/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionsFunnelStepDataSchema = z.object({
	step: z.string(),
	label: z.string(),
	sessions: z.number(),
	conversionRate: z.number().nullable(),
	rateFromBaseline: z.number().nullable(),
})

export type AdditionalQuestionsFunnelStepDataSchema = z.infer<typeof additionalQuestionsFunnelStepDataSchema>
